import React from "react";
import { Col, Row } from "@amzn/stencil-react-components/layout";
import "../sda/styles.scss";
import { cardBackgroundColor } from "../../config/palette";
import { H3 } from "../typography";
import { Text } from "@amzn/stencil-react-components/text";
import { Link } from "@amzn/stencil-react-components/link";

const linkStyle = {
  cursor: "pointer",
};

interface PreHireAppointmentCardHeaderProps {
  nheDate?: string;
  onViewDetailsClick: () => void;
  onViewListOfDocsClick: () => void;
}

export const PreHireAppointmentCardHeader = ({
  nheDate,
  onViewDetailsClick,
  onViewListOfDocsClick,
}: PreHireAppointmentCardHeaderProps) => {
  const documentLink = (
    <Link
      target="_blank"
      href="https://www.uscis.gov/i-9-central/form-i-9-acceptable-documents"
      onClick={onViewListOfDocsClick}
    >
      list of documents
    </Link>
  );
  return (
    <Col backgroundColor={cardBackgroundColor} padding="1rem">
      <Row padding="0.2rem">
        <Col padding="0.2rem">
          <H3 fontSize="T200" fontWeight="bold">
            Your pre-hire appointment is scheduled for {nheDate}
          </H3>
        </Col>
      </Row>
      <Row padding="0.2rem">
        <Col padding="0.2rem">
          <Text fontSize="T200">
            You&#39;ll be asked to complete your drug test and work
            authorization. Here is a {documentLink} you need to bring during the
            appointment.
          </Text>
        </Col>
      </Row>
      <Row padding="0.2rem">
        <Col padding="0.2rem">
          <Link
            textDecoration="none"
            style={linkStyle}
            onClick={onViewDetailsClick}
          >
            <Text fontSize="T200">View appointment details</Text>
          </Link>
        </Col>
      </Row>
    </Col>
  );
};
